import { render, staticRenderFns } from "./GoArtHeaderBar.vue?vue&type=template&id=1ddfe85b&scoped=true"
import script from "./GoArtHeaderBar.vue?vue&type=script&lang=js"
export * from "./GoArtHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./GoArtHeaderBar.vue?vue&type=style&index=0&id=1ddfe85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfe85b",
  null
  
)

export default component.exports